import React from 'react';
import { Button } from '../UI/Button';
export const Newsletter = () => {
  return <section className="py-16 bg-secondary/5" data-id="element-515">
      <div className="container mx-auto px-4" data-id="element-516">
        <div className="max-w-3xl mx-auto text-center" data-id="element-517">
          <h2 className="text-3xl font-bold mb-6 text-secondary-dark" data-id="element-518">
            Stay Connected
          </h2>
          <p className="text-secondary mb-8" data-id="element-519">
            Subscribe to our newsletter for the latest events, opportunities,
            and success stories.
          </p>
          <div className="flex flex-col sm:flex-row gap-4" data-id="element-520">
            <input type="email" placeholder="Enter your email address" className="flex-grow px-4 py-2 border border-gray-300 rounded-md focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none" data-id="element-521" />
            <Button data-id="element-522">Subscribe</Button>
          </div>
        </div>
      </div>
    </section>;
};